// extracted by mini-css-extract-plugin
module.exports = {"logosList__logos":"LogosList-module--logos-list__logos--3w89u","logosList__logoImage":"LogosList-module--logos-list__logo-image--1Wd7y"};